import { AssessmentResultRecordType } from "../types";

export default function getAssessmentDate(
  assessment: AssessmentResultRecordType
) {
  return assessment.date;
}
